/**
 */
export default () => {
    const homeDom = document.querySelector('meta[name="home.properties"]');
    const homeProperties = homeDom?.getAttribute('content');
    return (homeProperties && JSON.parse(homeProperties)) || {};
}